// reducer.js
import {
  FETCH_FEEDBACKS_REQUEST,
  FETCH_FEEDBACKS_SUCCESS,
  FETCH_FEEDBACKS_FAILURE,
} from './actionTypes'

const initialState = {
  feedbacks: [],
  loading: false,
  error: null,
}

const feedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FEEDBACKS_REQUEST:
      return { ...state, loading: true, error: null }

    case FETCH_FEEDBACKS_SUCCESS:
      return { ...state, loading: false, feedbacks: action.payload }

    case FETCH_FEEDBACKS_FAILURE:
      return { ...state, loading: false, error: action.payload }

    default:
      return state
  }
}

export default feedbackReducer
